/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from '../ComponentBase';
import CLog, { LogTypes } from '../ComponentLogger';
import { AnyFunc } from '../Types';

/** Abstract component class for running in editor. */
@cc._decorator.ccclass
export default abstract class EditorComponentBase extends ComponentBase
{
    /** @hidden */
    private _logPrefix: string = '';

    /** @hidden */
    protected onLoad(prefix: string = null): void
    {
        super.onLoad();
        this._logPrefix = `${prefix || this.node.name} - `;
    }

    /** Log message. */
    protected log(message: string): void
    {
        if (CC_EDITOR)
        {
            cc.log(this._logPrefix + message);
            return;
        }
        CLog.log(this._logPrefix + message, LogTypes.Editor, this);
    }

    /** Log warning message. */
    protected warn(message: string): void
    {
        if (CC_EDITOR)
        {
            cc.warn(this._logPrefix + message);
            return;
        }
        CLog.warn(this._logPrefix + message, LogTypes.Editor, this);
    }

    /** Log error message. */
    protected error(message: string): void
    {
        if (CC_EDITOR)
        {
            cc.error(this._logPrefix + message);
            return;
        }
        CLog.error(this._logPrefix + message, this, LogTypes.Editor);
    }

    /** @hidden */
    public scheduleOnce(fnToSchedule: AnyFunc, delaySS: number = 0): void
    {
        if (CC_EDITOR)
        {
            setTimeout(fnToSchedule, delaySS * 1000);
            return;
        }

        super.scheduleOnce(fnToSchedule, delaySS);
    }
}
